const localStorageSwitcherKey = "hrhubenv";

export const isDevelopment = import.meta.env.APP_NODE_ENV === "development";

export const getStorageSwitcher = () => {
  if (isDevelopment && localStorage.getItem(localStorageSwitcherKey)) {
    const envData = JSON.parse(localStorage.getItem(localStorageSwitcherKey));
    return envData;
  }

  return {
    APP_BASE_API_URL: import.meta.env.APP_BASE_API_URL,
    APP_BASE_API_RESTAURANT_URL: import.meta.env.APP_BASE_API_RESTAURANT_URL,
    APP_BASE_API_PRICE_ENGINE_URL: import.meta.env.APP_BASE_API_PRICE_ENGINE_URL,
    APP_HH_MENU_API_URL: import.meta.env.APP_HH_MENU_API_URL,
    APP_CHART_URL: import.meta.env.APP_CHART_URL,
  };
};

export const setStorageSwitcher = (data) => {
  if (isDevelopment) {
    const envData = {
      ENV_KEY: data.envKey,
      APP_BASE_API_URL: data.baseApiUrl,
      APP_BASE_API_RESTAURANT_URL: data.baseApiRestaurantUrl,
      APP_BASE_API_PRICE_ENGINE_URL: data.baseApiPriceEngineUrl,
      APP_HH_MENU_API_URL: data.hhMenuApiUrl,
      APP_CHART_URL: data.chartUrl,
    };
    // Save the environment data in localStorage
    localStorage.setItem(localStorageSwitcherKey, JSON.stringify(envData));
  }
};

export const storageSwitcher = () => {
  if (isDevelopment) {
    // Check if the key exists in localStorage
    if (!localStorage.getItem(localStorageSwitcherKey)) {
      // Create an object with the necessary environment variables
      const envData = {
        ENV_KEY: "env",
        APP_BASE_API_URL: import.meta.env.APP_BASE_API_URL,
        APP_BASE_API_RESTAURANT_URL: import.meta.env.APP_BASE_API_RESTAURANT_URL,
        APP_BASE_API_PRICE_ENGINE_URL: import.meta.env.APP_BASE_API_PRICE_ENGINE_URL,
        APP_HH_MENU_API_URL: import.meta.env.APP_HH_MENU_API_URL,
        APP_CHART_URL: import.meta.env.APP_CHART_URL,
      };
      // Save the environment data in localStorage
      localStorage.setItem(localStorageSwitcherKey, JSON.stringify(envData));
    }
  } else {
    // Remove the key from localStorage
    console.log("Remove localStorage");
    localStorage.removeItem("hrhubenv");
  }
};

export const getStorageBookingPreviousQueryParam = () => {
  return localStorage.getItem("hhPreviousBookingQueryParam");
};

export const setStorageBookingPreviousQueryParam = (payload) => {
  localStorage.setItem("hhPreviousBookingQueryParam", payload);
};

export const getStorageBookingTableInfo = () => {
  return localStorage.getItem("hhPreviousBookingTableInfo");
};

export const setStorageBookingTableInfo = (payload) => {
  localStorage.setItem("hhPreviousBookingTableInfo", payload);
};

export const removeStorageBookingTableInfo = () => {
  localStorage.removeItem("hhPreviousBookingTableInfo");
};

export const getStorageSidebarMiniStatus = () => {
  return localStorage.getItem("hhSidebarMiniStatus");
};

export const setStorageSidebarMiniStatus = (payload) => {
  localStorage.setItem("hhSidebarMiniStatus", String(payload));
};
